import React from "react";

import { Transition } from 'react-transition-group';

export const Fade = ({ in: inProp, duration, children }) => {
    const defaultStyle = {
        transition: `opacity ${duration ?? 300}ms ease-in-out`,
        opacity: 0,
    }

    const transitionStyles = {
        entering: { opacity: 1 },
        entered: { opacity: 1 },
        exiting: { opacity: 0 },
        exited: { opacity: 0 },
    };
    return (
        <Transition in={inProp} timeout={duration ?? 300}>
            {state => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                    {children}
                </div>
            )}
        </Transition>
    );
}